import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { SessionCheck, generateAlertMessage,AuthFailedMessage } from '../../../../app-general';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { AddNewUnitForm } from '../../technologyoverlay';
import { TooltipPosition } from "@angular/material/tooltip";
import { appsettings } from '../../../../app-settings';

@Component({
  selector: 'app-add-outdoorspace',
  templateUrl: './add-outdoorspace.component.html',
  styleUrls: ['./add-outdoorspace.component.scss']
})

export class AddOutdoorspaceComponent implements OnInit {

  public addoutdoorspaceForm : FormGroup;
  watcher: Subscription;
  columns: number = 3;
  selectedCampus;
  campusinfo;
  newCampusInfo;
  addoutdoorbool : boolean = true;  
  SiteId = "1";
  SvgPoints;
  roomX=0;
  roomY=0;
  maxSpaceId;
  matTooltipSpaceId = "The Space ID is an auto-number field that starts at (1) when the Approximate Space is first created. This field is editable.";
  matTooltipLocAccuracy = "Location Accuracy will be populated when available on signature server. This field is not editable.";
  positionOptions: TooltipPosition[] = [
  "after",
  "before",
  "above",
  "below",
  "left",
  "right",
  ];
  position = new FormControl(this.positionOptions[3]);
  private _onDestroy: Subject<void> = new Subject<void>();  
  checkCampusorZone = 0;
  checkApproximate = false;
  approxDescription = "";  
  
  constructor(mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<AddOutdoorspaceComponent>,private router: Router,@Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService,public dialog: MatDialog) {        
    this.SvgPoints = data.PolyPoints;
    this.roomX = data.roomX;
    this.roomY = data.roomY;
    
    if(data.BuildingName == "")
      this.approxDescription = data.CampusName;
    else if(data.FloorName == "")
      this.approxDescription = data.BuildingName + "," + data.CampusName;
    else
      this.approxDescription = data.FloorName + "," + data.BuildingName + "," + data.CampusName; 
      
    if(data.BuildId == 0)
      this.checkApproximate = false;
    else
      this.checkApproximate = true;
          
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {           
        if (change.mqAlias == 'xs') {
          this.columns = 2;
        } 
        else {
          this.columns = 3;
        }                
      }
    });
   }

  ngOnInit() {
    this.addoutdoorspaceForm = new FormGroup({
      campus: new FormControl(''),
      campusId: new FormControl(''),
      building: new FormControl(''),
      buildId: new FormControl(""),
      floor: new FormControl(''),
      floorId: new FormControl(""),
      name:new FormControl('',[Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
      spaceId: new FormControl("", [ Validators.required, Validators.pattern("^[0-9-%]*"), Validators.min(1)]),
      accuracy: new FormControl(''),
    });
    
    this.getOutdoorSpaceId();
    this.addoutdoorspaceForm.get('campus').disable();   
    // this.addoutdoorspaceForm.get('building').disable();   
    // this.addoutdoorspaceForm.get('floor').disable();   
    this.addoutdoorspaceForm.get('accuracy').disable();     
  }
  
  


getOutdoorSpaceId()
  {
    const spaceinfo: any = {
      siteId:this.SiteId,
      authKey: localStorage.getItem("Authkey")
    }
    this.technologyoverlayService
    .getSpaceId(spaceinfo)
    .pipe(takeUntil(this._onDestroy))
    .subscribe((OutdoorSpaceinfo: any[]) => {
      this.maxSpaceId = OutdoorSpaceinfo[0].SpaceId;
    })
  }

removeDuplicates(originalArray, prop)
{
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
}

  
public onCloseCancel = () => 
{      
    this.thisDialogRef.close('Cancel'); 
    if(!SessionCheck(this.router))
    {
        return;
    }   
}

public hasError = (controlName: string, errorName: string) =>
{
    this.addoutdoorspaceForm.controls[controlName].hasError(errorName);       
}  

outdoor_selectCampus(selectcampus)
{
    try
    {
      this.selectedCampus = selectcampus;
      // this.getfilterCusLocatorsdetails();       
    }
    catch(err)
    {
      throw new Error('customizelocators.component.ts' + ' - cusloc_selectLocationType() - ' + err.message);
    }
}

newaddOutdoor(addOutdoorFormValue)
  {
    try
    {
      if(!SessionCheck(this.router))
      {
         this.thisDialogRef.close('Cancel'); 
          return;
      }
        (document.activeElement as HTMLTextAreaElement).blur();
        
        if (this.addoutdoorspaceForm.valid && this.addoutdoorbool) 
        {             
          this.addoutdoorbool = false;
          let saveclick = document.getElementById('btnsaveoutdooraddclick');
          saveclick.className = 'clsaddoutsavebutton mat-raised-button disablebtn'; 
          this.onDrawOverlayClicked(addOutdoorFormValue);    
        }
    }
    catch(err)
    {
      throw new Error('add-building.component.ts' + ' - newaddBuilding() - ' + err.message);
    }
  }
  
onDrawOverlayClicked(addOutdoorFormValue)
{    
  let saveclick = document.getElementById('btnsaveoutdooraddclick');
      saveclick.className = 'clsaddoutsavebutton mat-raised-button disablebtn';
      
  let _Description = "";        
  if(addOutdoorFormValue.description != "")
    _Description = addOutdoorFormValue.description.replace(/\s+/g, ' ').trim();
  else
    _Description = "";
              
  let unitdetails: AddNewUnitForm = {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey"),
    campusId:parseInt(addOutdoorFormValue.campusId),
    buildId: parseInt(addOutdoorFormValue.buildId),
    floorId: parseInt(addOutdoorFormValue.floorId), 
    unitName:addOutdoorFormValue.name.replace(/\s+/g, ' ').trim(),                
    description:_Description,//addOutdoorFormValue.description.replace(/\s+/g, ' ').trim(),              
    spaceCategoryId:0,   
    svgpoints: this.SvgPoints.toString(),
    isIndoor:0,
    accuracy:'',//addOutdoorFormValue.accuracy.toString(),
    resOffLimits:0,
    spaceId: parseInt(addOutdoorFormValue.spaceId),
    chkAllday : 0,
    resStartHr : 0,
    resStartMi : 0,
    resEndHr : 0,
    resEndMi : 0,
    roomX:this.roomX,
    roomY:this.roomY,

  }
            
  this.technologyoverlayService.addSpaceWithRoom(unitdetails).pipe(takeUntil(this._onDestroy))
  .subscribe((apiresponse : any[])=>{
    
      if(apiresponse["apiReturn"].toString() == "Success")
      { 	
        generateAlertMessage(this.dialog, 'Space added successfully.');               
        this.thisDialogRef.close('Confirm');
      }
      else if(apiresponse["apiReturn"].toString() == "Fail")
      { 	    
        this.addoutdoorbool = true;
        generateAlertMessage(this.dialog, 'Space added failed.');          
        this.thisDialogRef.close('Confirm');
      }                
      else if(apiresponse["apiReturn"] == "Invalid Auth Key")
      {    
          this.thisDialogRef.close('close');              
          AuthFailedMessage(this.dialog,this.router);  
          return;       
      } 
      else if(apiresponse["apiReturn"] == "Unit Name empty")
      {
        this.addoutdoorbool = true;
        generateAlertMessage(this.dialog, 'Please enter Space Name');                  
        saveclick.className = 'clsaddoutsavebutton mat-raised-button'; 
        return; 
      }
      else if (apiresponse["apiReturn"] == "spaceId") {
        this.addoutdoorbool = true;
        generateAlertMessage(this.dialog, "Space Id already exists, Please try with different Id.");          
        saveclick.className = 'clsaddoutsavebutton mat-raised-button'; 
        return;
      }
      else
      { 	    
        this.addoutdoorbool = true;
        generateAlertMessage(this.dialog, "Space name '" + apiresponse[0].UnitName + "' already exists."); 
        saveclick.className = 'clsaddoutsavebutton mat-raised-button';  
        return;
      }  
      
      let Doneclick = document.getElementById('divrightsidebar');
      Doneclick.className = 'clsrightside_outicon';
  });
          
  
}
  

}
